(() => {
  const section = document.querySelector('[data-hx-blockmeta]');
  if (!section) return;

  // delays for heading elements
  section.querySelectorAll('[data-hx-delay]').forEach(el => {
    el.style.transitionDelay = el.getAttribute('data-hx-delay') || '0ms';
  });

  // stagger cards
  const base = 170; // ms
  const step = 130; // ms
  section.querySelectorAll('[data-hx-stagger]').forEach(el => {
    const i = parseInt(el.getAttribute('data-hx-stagger') || '0', 10);
    el.style.transitionDelay = (base + (i * step)) + 'ms';
  });

  // reveal on scroll (like other sections)
  const reveal = () => section.classList.add('hx-inview');

  if (!('IntersectionObserver' in window)) {
    reveal();
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        reveal();
        io.disconnect();
      }
    });
  }, { threshold: 0.18 });

  io.observe(section);
})();
